/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RegenerateKeyRequest {
    getFixupPrototypeFunction() { return RegenerateKeyRequest.fixupPrototype; }

    static newInstance(model: Partial<RegenerateKeyRequest>): RegenerateKeyRequest {
        let obj = Object.assign(new RegenerateKeyRequest(), model);
        RegenerateKeyRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RegenerateKeyRequest>): RegenerateKeyRequest {
        if (!model) return null;
        return RegenerateKeyRequest.newInstance(<RegenerateKeyRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RegenerateKeyRequest) {
        if (!obj) return;

        models.RegenerateKeyRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RegenerateKeyRequest): boolean {
        Object.setPrototypeOf(obj, RegenerateKeyRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Update whether access key is required for this user.
     */
    require_access_key: boolean;

}
